import { gql } from '@apollo/client'
export const GET_ALL_SURVEYS = gql`
  query GetAllSurveys($searchQuery: String, $limit: Int, $offset: Int) {
    getAllSurveys(searchQuery: $searchQuery, limit: $limit, offset: $offset) {
      count
      rows {
        id
        title
        description
        status
        start_date
        end_date
        is_active
        user_delete_id
        user_register_id
        user_update_id
      }
    }
  }
`

export const GET_ONE_SURVEY_BY_ID = gql`
  query GetOneSurveysById($id: Int) {
    getOneSurveysById(id: $id) {
      id
      title
      description
      start_date
      end_date
      is_active
      user_delete_id
      user_update_id
      user_register_id
      surveysToSurveysQuestions {
        id
        order
        question_text
        survey_id
        type_question_id
        is_required
        surveysQuestionsTosurveyQuestionType {
          id
          key
          name
        }
        surveysQuestionsToSurveyQuestionOptions {
          id
          question_id
          option_text
          order
          value
        }
      }
    }
  }
`

export const CREATE_SURVEY = gql`
  mutation CreateSurvey($input: inputSurveys) {
    createSurvey(input: $input)
  }
`

export const UPDATE_SURVEY = gql`
  mutation UpdateSurvey(
    $updateSurveyId: Int
    $input: inputSurveys
    $idsDeleteQuestions: [Int]
    $idsDeleteQuestionsOptions: [Int]
  ) {
    updateSurvey(
      id: $updateSurveyId
      input: $input
      idsDeleteQuestions: $idsDeleteQuestions
      idsDeleteQuestionsOptions: $idsDeleteQuestionsOptions
    )
  }
`
export const DELETE_SURVEY = gql`
  mutation DeleteSurvey($id: Int) {
    deleteSurvey(id: $id)
  }
`
export const CHANGE_STATUS_SURVEY = gql`
  mutation ChangeStatusSurvey($id: Int, $status: Int) {
    changeStatusSurvey(id: $id, status: $status)
  }
`
